import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue, useMemo, useState } from "react";
import { inBrowser } from "@lilib/utils";
import useUpdate from "./useUpdate";
import useEventListener from "./useEventListener";
function useMatchMedia(query, defaultValue) {
  var media = useMemo(function () {
    return inBrowser ? window.matchMedia(query) : null;
  }, [query]);
  var _useState = useState(media ? media.matches : !!defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    matches = _useState2[0],
    setMathes = _useState2[1];
  useUpdate(function () {
    setMathes(media ? media.matches : !!defaultValue);
  }, [media]);
  useEventListener(media, "change", function (event) {
    setMathes(event.matches);
  });
  useDebugValue(query + " is " + matches);
  return matches;
}
export default useMatchMedia;